<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            
            <div class="print-title-view">
                <div v-if="isEditTitle" class="print-title">
                    <el-input type="text" style="width: 70%" v-model="titleConfig.RValue"></el-input>
                </div>
                <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
            </div>
            <div class="print-content">
                <div>退货单号：{{ returnCode }}</div>
                <div>退货日期：{{ orderData.ReturnTime }}</div>
            </div>
            <div class="print-table-main">
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%;">供应商名称</div>
                    <div class="div-table-cell" style="width: 80%">{{ orderData.EntpCusName }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%">联系电话</div>
                    <div class="div-table-cell" style="width: 80%"></div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 6%">序号</div>
                    <div class="div-table-cell" style="width: 20%;">汽配编码</div>
                    <div class="div-table-cell" style="width: 20%;">配件名称</div>
                    <div class="div-table-cell" style="width: 20%;">车型</div>
                    <div class="div-table-cell" style="width: 7%">数量</div>
                    <div class="div-table-cell" style="width: 7%">单位</div>
                    <div class="div-table-cell" style="width: 10%">退单价</div>
                    <div class="div-table-cell" style="width: 10%">退款金额</div>
                </div>
                <div class="div-table-row" v-for="(AP, index) in orderData.DetailList" :key="index">
                    <div class="div-table-cell" style="width: 6%">{{ index + 1 }}</div>
                    <div class="div-table-cell" style="width: 20%;">{{ AP.APCode }}</div>
                    <div class="div-table-cell" style="width: 20%;">{{ AP.GoodName }}</div>
                    <div class="div-table-cell" style="width: 20%;">适用:{{ AP.AutoSerise }}</div>
                    <div class="div-table-cell" style="width: 7%">{{ AP.ReturnCount }}</div>
                    <div class="div-table-cell" style="width: 7%">{{ AP.Unit }}</div>
                    <div class="div-table-cell" style="width: 10%">{{ AP.PurchasePrice }}</div>
                    <div class="div-table-cell" style="width: 10%">{{ (AP.PurchasePrice * AP.ReturnCount).toFixed(2) }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 6%"></div>
                    <div class="div-table-cell" style="width: 20%;"></div>
                    <div class="div-table-cell" style="width: 20%;"></div>
                    <div class="div-table-cell" style="width: 20%;">总数量</div>
                    <div class="div-table-cell" style="width: 7%">{{ orderData._count }}</div>
                    <div class="div-table-cell" style="width: 7%">总价</div>
                    <div class="div-table-cell" style="width: 10%">{{ orderData._sum }}</div>
                    <div class="div-table-cell" style="width: 10%">{{ orderData.ReturnMoney }}</div>
                </div>
            </div>
            <div class="row">
                <div style="display: inline-block;">退款方式：{{ orderData.PayTypeName }}</div>
                <div style="display: inline-block;float: right;">开单人：{{ orderData.Creator }}</div>
            </div>
            <div class="row">退货原因：{{ orderData.Reasons }}</div>
        </div>
        <div class="dialog-footer">
            <div class="re-set">
                <el-button class="btn-primary" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle && !orderData.IsHaveTitleSet"
                    >编辑标题</el-button
                >
                <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
            </div>
            <div class="re-set">
                <el-button class="btn-primary" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            orderData: [],
            returnCode: '',
            isEditTitle: false, //编辑标题
            company: userMsg.EntpName,
            titleConfig: {
                RValue: userMsg.EntpName + '采购入库退货单'
            }, //标题配置
            isPrint: false,
            isPreview: false,
            isDefaultSet: false
        };
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.printList = [];
            this.getConfigByCodes().then(() => {
                this.getOrder();
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyyl', 'syllqdysz','dycgshbt'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                                case 'dycgshbt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '采购入库退货单';
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                            .order-detail {
                            color: #000;
                            }
                            .order-remark {
                                width: 762px;
                            display: -webkit-flex;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-left: 10px;
                            margin-right: 10px;
                            padding: 0px 0px 15px 0px;
                            color: #000;
                            }
                            .print-title {
                            text-align: center;
                            font-size: 20px;
                            font-weight: bold;
                            color: #000;
                            }
                            .print-content {width: 762px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            color: #000;
                            margin: 12px 0;
                            }
                            .dialog-footer {
                            text-align: right;
                            }
                            .print-table-main {
                            width: 762px;
                            margin-bottom: 16px;
                            font-size:12px;
                            
                            }
                            .div-table-cell {
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                height: auto;
                                line-height: 30px;
                                padding-left: 10px;
                                border-top: 1px solid #000;
                                border-right: 1px solid #000;
                                border-bottom: 1px solid #000;
                                color: #000;
                            }
                            .row {
                                width: 762px;
                            color: #000;
                            margin-bottom: 16px;
                            }
                            .div-table-row {
                                display: flex;
                                border-left: 1px solid #000;
                                margin: 0;
                                font-size: 14px;
                            }
                    </style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';
                let printHight = document.getElementById('printContent').clientHeight;

                // if (this.printList[0].DetailList.length <= 60) {
                if (printHight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '100%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0].PReturnId, Type: 10 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if(!this.isInit)
                        this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpPurReturnOrder/GetYCOrderDetailForPrint',
                    data: {
                        PReturnId: this.printIds[0].PReturnId
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let data = res.data;
                    let detailList = data.DetailList;
                    let values = detailList.reduce(
                        (p, e) => {
                            return {
                                _count: e.ReturnCount * 1 + p._count,
                                _sum: e.PurchasePrice + p._sum
                            };
                        },
                        {
                            _count: 0,
                            _sum: 0
                        }
                    );
                    Object.assign(data, values);
                    this.orderData = data;
                    this.returnCode = this.printIds[0].ReturnCode;
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }                    
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.print-title-view {
    width: 100%;
    position: relative;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0; 
}
.order-detail {
    color: #000;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.print-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #000;
    margin: 12px 0;
}
.dialog-footer {
    display: flex;
    justify-content: space-between;
}
.print-table-main {
    margin-bottom: 16px;
    font-size: 12px;
    .div-table-row {
        border-color: black;
        margin-left: 0;
    }
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
}
.row {
    color: #000;
    margin-bottom: 16px;
}
</style>
